module.exports = __webpack_public_path__ + "img/lead-pencil.34372ea7.svg";